import { RestService } from './ResyService';
import { AlarmaEndpoint } from './config';

export class AlarmsService extends RestService {

    getAllAlarms(param?,filter?) {
        return this.get(AlarmaEndpoint.get + '?plant_id=' + param + '&' + 'filter=' + filter);

    }
    getPlantAlarms(param) {
        return this.get(AlarmaEndpoint.get + '?plant_id=' + param);
    }
    checkStatus(id) {
        let body = {
            "serial_id": id
        }
        return this.post(AlarmaEndpoint.post, body)
    }
}